export const AppTitle = process.env.VUE_APP_TITLE;
export const AuthUrl = process.env.VUE_APP_AUTH_URL;
export const AuthCookieDomainUrl = process.env.VUE_APP_AUTH_COOKIE_DOMAIN;
export const ClientId = process.env.VUE_APP_AUTH_CLIENT_ID;
export const StripeKey = process.env.VUE_APP_STRIPE_KEY;
export const HostGameUrl = process.env.VUE_APP_HOST_GAME_URL;
